import React, { FormEvent } from "react";
import AppIcons from "../../utils/AppIcons";

interface IFormInputRadioButtonProps {
  label: string;
  id: string;
  value: string | number | undefined;
  selectedValue: string | number | undefined;
  required?: boolean | undefined;
  details?: string;
  onChange: (id: string, value: string | number | undefined) => void;
  error?: string | undefined;
  css_label?: string | undefined;
  hint?: string;
}

function FormInputRadioButton({
  label,
  id,
  value,
  selectedValue,
  required,
  details,
  onChange,
  error,
  css_label,
  hint = "",
}: IFormInputRadioButtonProps) {
  const checked = value === selectedValue;

  return (
    <div key={"key_" + id}>
      {label && (
        <label htmlFor={id} className={css_label ? css_label : "form-label"}>
          {label}
          {required && <>*</>}
        </label>
      )}
      <label className="cursor-pointer" onClick={(e) => onChange(id, value)}>
        <div className="form-radio-button">{checked && AppIcons.CIRCLE} </div>
        {details}
      </label>
      <input
        className="hidden"
        type="checkbox"
        name={id}
        id={id}
        checked={checked}
        required={required}
        onChange={() => {}}
      />
      {hint && <div className="form-hint ml-6 mr-4">{hint}</div>}
      {error && <div className="form-error">{error}</div>}
    </div>
  );
}

export default FormInputRadioButton;
